import { render } from "./TrainingWidget.vue?vue&type=template&id=6354ea3a&scoped=true"
import script from "./TrainingWidget.vue?vue&type=script&lang=js"
export * from "./TrainingWidget.vue?vue&type=script&lang=js"

import "./TrainingWidget.vue?vue&type=style&index=0&id=6354ea3a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6354ea3a"]])

export default __exports__